import { render } from "./ForSaleAsksComponent.vue?vue&type=template&id=2c32d078&scoped=true"
import script from "./ForSaleAsksComponent.vue?vue&type=script&lang=js"
export * from "./ForSaleAsksComponent.vue?vue&type=script&lang=js"

import "./ForSaleAsksComponent.vue?vue&type=style&index=0&id=2c32d078&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c32d078"]])

export default __exports__